import { AddressBlock, Input, InputEmail, InputPhone } from '@/components/form';
import { RequiredField } from '@/interfaces';
import { errorFieldMessage } from '@/const';
import { parseAddressResponse } from '@/components/form/input-address/address-block';
import clsx from 'clsx';
import * as React from 'react';
import {
	FieldErrors,
	FieldValues,
	UseFormRegister,
	UseFormSetValue,
	UseFormWatch,
} from 'react-hook-form';

interface ModalReviewSignFieldsProps {
	fields: RequiredField[];
	isDocumentRead?: boolean;
	register: UseFormRegister<FieldValues>;
	setValue: UseFormSetValue<FieldValues>;
	watch: UseFormWatch<FieldValues>;
	errors: FieldErrors<FieldValues>;
	isCompleted?: boolean;
}

export const allowIntegersOnlyOnChange = (e: any) => {
	const value = e.target.value;
	e.target.value = value.replace(/\D+/g, '');
};

export const ModalReviewSignFields: React.FC<ModalReviewSignFieldsProps> = ({
	fields,
	isDocumentRead = true,
	register,
	setValue,
	watch,
	errors,
	isCompleted,
}) => {
	return (
		<>
			{fields.map((field) => {
				if (field.type === 'EMAIL') {
					return (
						<InputEmail
							key={field.question_id}
							title={field.question}
							name={`field-${field.question_id}`}
							register={register}
							rules={{
								required: { value: true, message: 'This field is required' },
							}}
							error={errors[`field-${field.question_id}`]}
							disabled={!isDocumentRead || isCompleted}
							classNameInput={clsx(`disabled:!bg-[#F4F4F4A3]  !h-12`)}
							classNameTitle="capitalize"
							setValueCustom={setValue}
						/>
					);
				}
				if (field.type === 'ADDRESS') {
					const id = field.question_id;
					const requiredRule = {
						required: { value: true, message: errorFieldMessage },
					};
					const parsed = parseAddressResponse(field.response ?? '');
					return (
						<div key={id}>
							{/* {field.question ? (
								<Typography type="regular-16" className="capitalize text-left">
									{field.question}
								</Typography>
							) : null} */}
							<AddressBlock
								register={register}
								setValue={setValue}
								watch={watch}
								errors={errors}
								defaultAddress1={parsed?.address1 || field.response || ''}
								initialAddress2={parsed?.address2}
								initialCityName={parsed?.city}
								initialStateName={parsed?.state}
								initialZip={parsed?.zip}
								address1Name={`addr-${id}-line1`}
								address2Name={`addr-${id}-line2`}
								stateDisplayName={`addr-${id}-state`}
								cityDisplayName={`addr-${id}-city`}
								zipName={`addr-${id}-zip`}
								responseName={`field-${id}`}
								showLocationFields={false}
								disabled={!isDocumentRead || isCompleted}
								className="!flex-col space-y-4 border-none !py-0"
								classNameInput="md:!w-full"
								rules={{
									address: requiredRule,
								}}
							/>
						</div>
					);
				}
				if (field.type === 'PHONE') {
					return (
						<InputPhone
							key={field.question_id}
							title={field.question}
							name={`field-${field.question_id}`}
							register={register}
							rules={{
								required: { value: true, message: 'This field is required' },
							}}
							customErrorMessage="Please enter a valid phone number."
							error={errors[`field-${field.question_id}`]}
							disabled={!isDocumentRead || isCompleted}
							classNameInput={clsx(`disabled:!bg-[#F4F4F4A3]  !h-12`)}
							classNameTitle="capitalize"
							setValueInput={setValue}
						/>
					);
				}
				if (field.type === 'TEXT' || field.type === 'NUMBER') {
					return (
						<Input
							type="text"
							inputMode={field.type === 'NUMBER' ? 'numeric' : undefined}
							pattern={field.type === 'NUMBER' ? '[0-9]*' : undefined}
							key={field.question_id}
							title={field.question}
							name={`field-${field.question_id}`}
							register={register}
							rules={{
								required: { value: true, message: 'This field is required' },
							}}
							onChangeCustom={
								field.type === 'NUMBER' ? allowIntegersOnlyOnChange : undefined
							}
							disabled={!isDocumentRead || isCompleted}
							classNameInput={clsx(`disabled:!bg-[#F4F4F4A3]  !h-12`)}
							classNameTitle="capitalize"
							error={errors[`field-${field.question_id}`]}
						/>
					);
				}
				return (
					<Input
						key={field.question_id}
						title={field.question}
						name={`field-${field.question_id}`}
						register={register}
						rules={{
							required: { value: true, message: 'This field is required' },
						}}
						disabled={!isDocumentRead || isCompleted}
						classNameInput={clsx(`disabled:!bg-[#F4F4F4A3]  !h-12`)}
						classNameTitle="capitalize"
						error={errors[`field-${field.question_id}`]}
					/>
				);
			})}
		</>
	);
};
